import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

function CompletedSetIndicator({ data = [] }) {
  return (
    <>
      {data.map((set, index) => {
        return (
          <div
            key={index}
            className={classnames("CompletedSetIndicator_Box Score_Box", {
              CompletedSetIndicator_Winner: set.winner,
            })}
          >
            <span>{set.finalTieBreak ? set.tieBreakPoint : set.games}</span>
            {!set.finalTieBreak && set.tieBreakPoint > 0 && (
              <sup>{set.tieBreakPoint}</sup>
            )}
          </div>
        );
      })}
    </>
  );
}

CompletedSetIndicator.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      games: PropTypes.number.isRequired,
      tieBreakPoint: PropTypes.number,
      winner: PropTypes.bool.isRequired,
      finalTieBreak: PropTypes.bool,
    }),
  ),
};

export default CompletedSetIndicator;
